'use client'

import { useEffect } from 'react'

import { createNextRouterNavigation } from '../adapters/next-router-adapter'
import { CustomReferrer } from '../services/custom-referrer'
import { PageReloadTracker } from '../services/page-reload-tracker'

export function NavigationTrackingProvider() {
	useEffect(() => {
		const navigation = createNextRouterNavigation()

		const pageReloadTracker = new PageReloadTracker(navigation)
		const customReferrer = new CustomReferrer(navigation, pageReloadTracker)

		pageReloadTracker.init()
		customReferrer.init()

		return () => {
			customReferrer.destroy()
			pageReloadTracker.destroy()
		}
	}, [])

	return null
}
